export const DOCUMENT_ID_VERIFICATION_STEP_IDS = {
  DOCUMENT_TYPE_SELECTION: "DOCUMENT_TYPE_SELECTION",
  PROCESS_INFORMATION: "PROCESS_INFORMATION",
  DOCUMENT_ID_PICTURE_FRONT: "DOCUMENT_ID_PICTURE_FRONT",
  DOCUMENT_ID_PICTURE_BACK: "DOCUMENT_ID_PICTURE_BACK",
  VALIDATION_RESULT: "VALIDATION_RESULT",
  ID_VERIFICATION_EXTRACTED_DATA_FORM: "ID_VERIFICATION_EXTRACTED_DATA_FORM",
  NIE_EU_PASSPORT: "NIE_EU_PASSPORT",
  ADDITIONAL_DATA_GROUP: "ADDITIONAL_DATA_GROUP",
};

export const DOCUMENT_SIDES = {
  FRONT: "front",
  BACK: "back",
};

export const CAPTURE_MODES = {
  UPLOAD: "upload",
  CAMERA: "camera",
};

export const ID_DOCUMENT_VERIFICATION_STATUSES = {
  NULL: null,
  PENDING: "pending",
  FAILED: "failed",
  COMPLETED: "completed",
};

export const ID_DOCUMENT_VERIFICATION_RETRIABLE_HTTP_STATUS_CODES = [500];

export const ID_DOCUMENT_VERIFICATION_EXCEPTIONS = {
  INVALID_DOCUMENT_PHOTO: "InvalidDocumentPhotoException",
  PROCESS_EXPIRED: "ProcessExpiredException",
  TRANSACTIONAL_APPLICATION: "TransactionalApplicationException",
  NO_PENDING: "NoPendingIdDocumentVerificationException",
  PHOTOS_MISSING: "PhotosMissingException",
  ALREADY_COMPLETED: "AlreadyCompletedException",
  MAX_FAILED_ATTEMPTS_REACHED: "MaxFailedAttemptsReachedException",
};

export const getDocumentIdDocumentLabel = (documentType) => {
  if (!documentType) return "DNI/NIE";
  return documentType === "nif" ? "DNI" : "NIE";
};

/**
 * Backend exception strings are fully-qualified class names (namespaced),
 * e.g. "Nemuru\\...\\Exception\\PhotosMissingException".
 * We match by suffix to avoid coupling the UI to backend namespaces.
 */
export const idDocumentVerificationExceptionMatches = (
  exception,
  exceptionSuffix
) => {
  if (!exception || !exceptionSuffix) return false;
  return exception === exceptionSuffix || exception.endsWith(exceptionSuffix);
};
